import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Faqs = () => {
  return (
    <>
      <div className=" container my-5">
        <div className=" capacity-card">
          <div className=" capacity-card-body">
            <h1 className="text-center mb-4">FAQs</h1>

            <Accordion defaultActiveKey="0">
              <Row>
                <Col md={6}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      What is an OTC platform for electricity?
                    </Accordion.Header>
                    <Accordion.Body>
                      An OTC platform for electricity is a digital platform
                      where buyers and sellers can list their electricity
                      requirements, search for other buyers and sellers, and
                      contact them for further discussions. The OTC Platform
                      provides a flexible and customized approach to finding
                      buyers and sellers of electricity across India.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Are OTC Platforms regulated entities?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes. OTC Platforms for electricity are regulated by the
                      Central Electricity Regulatory Commission (CERC). CERC has
                      granted GNA Energy Private Limited registration to
                      establish and operate an OTC Platform for the Indian Power
                      Market.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Who can become a Member of the OTC Platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Various market participants, including generators,
                      utilities, discoms, industrial and commercial consumers,
                      trading licensees, educational and research institutions,
                      service providers, and regulatory bodies can become
                      Members of the OTC Platform. GNA Energy will conduct due
                      diligence on all membership applications before granting
                      membership. All members shall have to abide by the
                      Platform’s Business Rules and Bye-Laws.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      How can I apply for membership of the OTC Platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Membership applications can be submitted online by signing
                      up on our website, uploading the required documents, and
                      submitting the specified membership fees. In case you need
                      assistance in applying for the membership, please write to <Link to="mailto:info@gna.energy">info@gna.energy</Link>.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      What are the advantages of using an OTC platform for
                      electricity trading?
                    </Accordion.Header>
                    <Accordion.Body>
                      OTC platforms offer greater flexibility to tailor
                      requirements as per the specific needs of the buyer or
                      seller. It provides transparent access to all information
                      so that there are no hidden surprises and all market
                      participants can make informed decisions. Further, data
                      and analytics modules, including predictive analytics and
                      forecasting, provide market participants with insights
                      into the market. <br /> <br />
                      Lower cost commitments and greater transparency enable
                      small and mid-sized participants to take advantage of the
                      Open Access regulations
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      Can I negotiate or close a contract on the OTC Platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Currently, the OTC Platform only supports listing of
                      electricity requirements by buyers and sellers and
                      facilitates communication between them.
                    </Accordion.Body>
                  </Accordion.Item>
                </Col>
                <Col md={6}>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      Are there listings standardized on OTC platforms, or are
                      they customized?
                    </Accordion.Header>
                    <Accordion.Body>
                      OTC Platform listings can be customised for location,
                      source, pricing, and duration of your energy requirements,
                      giving you complete control over buying and selling
                      electricity.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      How is pricing determined on an OTC electricity platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Buyers and sellers can quote their desired pricing at the
                      time of listing their requirements on the OTC Platform.
                      Price discovery and negotiation take offline (outside the
                      OTC Platform) directly between buyers and sellers.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      How can OTC Platform members manage the risks associated
                      with listing electricity requirements on the OTC Platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Market participants should conduct due diligence on the
                      partners they select and analyse the information and
                      insights provided independently to manage their risk
                      exposure.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      Are there fees associated with using an OTC electricity
                      platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes. Please write to <Link to="mailto:info@gna.energy">info@gna.energy</Link> for details of the
                      fee structure.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      How can I access data and insights on an OTC electricity
                      platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Members get default access to base level data and insights
                      with their Membership. However, for granular/advanced
                      datasets, Members need to subscribe to the data and
                      insights service. Please write to <Link to="mailto:info@gna.energy">info@gna.energy</Link> for
                      details of the fee structure.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="11">
                    <Accordion.Header>
                      What are the reporting requirements for buy/sell listings
                      done on the OTC Platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      Please refer to GNA Energy Business Rules and Bye-Laws for
                      details.
                    </Accordion.Body>
                  </Accordion.Item>
                </Col>
              </Row>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqs;
